import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface Props {
    label: string;
    value?: string | null | React.ReactNode;
    labelWidth?: string | number;
}

export function InfoRow({ label, value, labelWidth = 160 }: Props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, py: 0.75 }}>
            <Typography variant="body2" color="text.secondary" sx={{ width: labelWidth, flexShrink: 0, fontSize: 12 }}>
                {label}
            </Typography>
            <Typography variant="body2" sx={{ flex: 1, fontWeight: 500, wordBreak: 'break-word' }}>
                {value ?? '—'}
            </Typography>
        </Box>
    );
}
